export default __webpack_public_path__ + "static/ndreams_studio_bg-929d5b88d1ea4ae125b4d4b3d9b68b5e.jpg";